var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isWaitingDialogActive)?_c('div',{staticClass:"dialog-background"},[_c('div',{staticClass:"waiting-text"},[_vm._v(" "+_vm._s(_vm.getWaitingText)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }